import { ZoneDimensions } from "../../types";
import { PageSaveState, State } from "../state";

export type SetTableCellsAction = Readonly<{
  cells: ReadonlyArray<ZoneDimensions>;
  type: "SET TABLE CELLS";
  zoneIndex: number;
}>;

export const setTableCells = (state: State, action: SetTableCellsAction): State => {
  const zone = state.pages[state.activePage].zones[action.zoneIndex];
  if (!Array.isArray(zone.cells)) {
    return state;
  }
  const zones = [
    ...state.pages[state.activePage].zones.slice(0, action.zoneIndex),
    {
      ...zone,
      cells: action.cells,
    },
    ...state.pages[state.activePage].zones.slice(action.zoneIndex + 1),
  ];
  const newPage = {
    ...state.pages[state.activePage],
    pageSaveState: PageSaveState.Dirty,
    zones,
  };
  const pages = [
    ...state.pages.slice(0, state.activePage),
    newPage,
    ...state.pages.slice(state.activePage + 1),
  ];
  return {
    ...state,
    pages,
  };
};
